import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={styles["icon-svg"] || "icon-svg"} width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18.5 18.5h5v5h-5v-5zm-9 0h5v5h-5v-5zm-9 0h5v5h-5v-5zm18-9h5v5h-5v-5zm-9 0h5v5h-5v-5zm-9 0h5v5h-5v-5zm18-9h5v5h-5v-5zm-9 0h5v5h-5v-5zm-9 0h5v5h-5v-5z" stroke="currentColor" fill="none" /></svg>;